import { Location } from "../organisation/Location"
import { Transactor, buildTransactorFromDetail } from "./Transactor"
import { User } from "./User"

export class Person {
    id: number
    firstname: string
    lastname: string
    user?: User
    location?: Location
    transactor?: Transactor
    fullname?: string
    email?: string
    phone_number?: string

    constructor(p: any) {
        this.id = p.id
        this.firstname = p.firstname
        this.lastname = p.lastname
        this.user = p.user
        this.location = p.location
        this.transactor = p.transactor
        this.fullname = p.fullname
        this.email = p.email
        this.phone_number = p.phone_number
    }

    getFullName(): string {
        if (this.fullname) {
            return this.fullname
        }
        let name: string = this.firstname
        if (this.lastname) {
            name = `${name} ${this.lastname}`
        }
        return name
    }

    static buildCRMPerson(p: any): Person {
        return new Person({
            ...p,
            firstname: p.first_name,
            lastname: p.last_name
        })
    }

    static build(p: any): Person|undefined {
        return new Person({
            id: p.id,
            firstname: p.firstname ?? p.first_name,
            lastname: p.lastname ?? p.last_name,
            user: p.user ? User.build(p.user) : null,
            location: p.location ? Location.build(p.location) : null,
            transactor: p.transactor ? buildTransactorFromDetail(p.transactor) : null,
            email: p.email,
            phone_number: p.phone_number})
    }
}